import { View } from "@react-pdf/renderer";
import { ResumePDFDescription } from "components/Resume/ResumePDF/common";
import { TemplateTwoPDFSection, TemplateThreeEnhancedSection } from "./common";
import { spacing, styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";

export const Custom = ({
  heading,
  custom,
}: {
  heading: string;
  custom: ResumeCustom;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateThreeEnhancedSection heading={heading}>
      <View style={{ ...styles.flexRow, gap: spacing[1.5] }}>
        <View style={{ width: "21%" }}></View>
        <View style={{ width: "79%" }}>
          <ResumePDFDescription items={descriptions} />
        </View>
      </View>
    </TemplateThreeEnhancedSection>
  );
};
